import { NotificationReason } from '@ninety/platform/models/notifications/notification-reason';

/**
 * Notification traits model for Segment identify calls.
 */
export interface NotificationTraits {
  email_enabled: boolean;
  web_enabled: boolean;
  mobile_enabled: boolean;
  assignment_enabled: boolean;
  comment_enabled: boolean;
  mention_enabled: boolean;
  headlines_enabled: boolean;
  [key: string]: boolean;
}

export interface SegmentFeedNotification {
  reason: NotificationReason;
  channels: {
    email: boolean;
    web: boolean;
    mobile: boolean;
  };
}

/**
 * Pure function to build notification traits from feed notifications.
 * Extracted for easier testing.
 */
export function buildNotificationTraits(feedNotifications: SegmentFeedNotification[]): NotificationTraits {
  const emailEnabled = feedNotifications.some(n => n.channels.email);
  const webEnabled = feedNotifications.some(n => n.channels.web);
  const mobileEnabled = feedNotifications.some(n => n.channels.mobile);

  const assignedNotification = feedNotifications.find(n => n.reason === 'assignment');
  const commentsNotification = feedNotifications.find(n => n.reason === 'comment');
  const mentionsNotification = feedNotifications.find(n => n.reason === 'mention');
  const headlinesNotification = feedNotifications.find(n => n.reason === 'itemSent');

  const hasAnyChannel = (n: SegmentFeedNotification | undefined): boolean =>
    !!n && (n.channels.email || n.channels.web || n.channels.mobile);

  return {
    email_enabled: emailEnabled,
    web_enabled: webEnabled,
    mobile_enabled: mobileEnabled,
    assignment_enabled: hasAnyChannel(assignedNotification),
    comment_enabled: hasAnyChannel(commentsNotification),
    mention_enabled: hasAnyChannel(mentionsNotification),
    headlines_enabled: hasAnyChannel(headlinesNotification),
  };
}
